<div
  *ngIf="!loading"
  class="px-3 pt-7 pb-8">
  <p class="font-medium text-2xl">Укажите дату и время для отправки письма</p>

  <div class="mt-5 text-left">
    <div class="field">
      <label class="font-medium required-field">Дата и время создания</label>
      <crm-datepicker
        [(value)]="newsletter.date"
        [showTime]="true"
        appendTo="body"
        styleClass="w-full"></crm-datepicker>
    </div>
  </div>

  <div class="flex justify-content-center mt-5">
    <crm-button
      type="button"
      label="Запустить"
      styleClass="p-button-success p-button-lg"
      (onClick)="startMailing()"></crm-button>
  </div>
</div>

<crm-spinner
  *ngIf="loading"
  top="mt-4"></crm-spinner>
